var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdminDashSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25013 16.5003C6.06206 16.5003 3.96356 15.6311 2.41641 14.0838C0.869186 12.5366 0 10.4383 0 8.25013C0 6.06193 0.869186 3.96356 2.41641 2.41641C3.96364 0.869186 6.06193 0 8.25013 0C10.4383 0 12.5367 0.869186 14.0838 2.41641C15.6311 3.96364 16.5003 6.06193 16.5003 8.25013C16.5003 10.4383 15.6311 12.5367 14.0838 14.0838C12.5366 15.6311 10.4383 16.5003 8.25013 16.5003ZM8.25013 1.50026C6.45986 1.50026 4.74304 2.21143 3.47713 3.47721C2.21134 4.74317 1.50017 6.45999 1.50017 8.25021C1.50017 10.0404 2.21134 11.7573 3.47713 13.0232C4.74309 14.289 6.4599 15.0002 8.25013 15.0002C10.0404 15.0002 11.7572 14.289 13.0231 13.0232C14.2889 11.7573 15.0001 10.0404 15.0001 8.25021C15.0001 6.45999 14.2889 4.74313 13.0231 3.47721C11.7572 2.21143 10.0404 1.50026 8.25013 1.50026V1.50026Z",
    fill: "#ECF9EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9944 14.0489L14.0551 12.9882L19.279 18.212L18.2182 19.2727L12.9944 14.0489Z",
    fill: "#ECF9EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25012 13.1257C6.95789 13.1237 5.71902 12.6094 4.80514 11.6957C3.89142 10.7818 3.37714 9.543 3.37512 8.25073H4.12512C4.12713 9.3441 4.56239 10.3923 5.33549 11.1654C6.10859 11.9385 7.15675 12.3737 8.25012 12.3757V13.1257Z",
    fill: "#ECF9EE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminDashSearch);
export default __webpack_public_path__ + "static/media/admin-dash-search.a271be37d208b53f7fbd21d4d867db6d.svg";
export { ForwardRef as ReactComponent };